import { Suspense } from "react"

import { useAuth0 } from "@auth0/auth0-react"
import { Slot } from "expo-router"

import { Box, Spinner } from "wealthmode-frontend/gluestack/ui"

import { BackendProvider } from "@/context"
import DefaultLayout from "@/layout/DefaultLayout"

import Login from "../(auth)/login"

function RequireAuth({ children }: { children: React.ReactNode }) {
  const { isLoading, isAuthenticated, error } = useAuth0()

  if (isLoading) {
    return (
      <Box className="bg-background-primary min-h-screen flex items-center justify-center">
        <Spinner size="large" />
      </Box>
    )
  }

  if (error) {
    return (
      <Box className="bg-background-primary min-h-screen flex items-center justify-center">
        <Box className="text-information-negative">Oops... {error.message}</Box>
      </Box>
    )
  }

  if (!isAuthenticated) {
    return <Login />
  }

  return <>{children}</>
}

export default function DashboardLayout() {
  return (
    <RequireAuth>
      <BackendProvider>
        <DefaultLayout>
          <Suspense
            fallback={
              <Box className="flex flex-1 min-h-0 items-center justify-center">
                <Spinner size="large" />
              </Box>
            }
          >
            <Box className="flex flex-1 min-h-0 flex-col overflow-hidden">
              <Slot />
            </Box>
          </Suspense>
        </DefaultLayout>
      </BackendProvider>
    </RequireAuth>
  )
}
